var _ellipse, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-database-backup-icon lucide-database-backup",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 9,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 3 0 0 0 5 2.69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.3V5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14a9 3 0 0 0 6.47 2.88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4h4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatas);
export default __webpack_public_path__ + "static/media/datas.9171b905e4c47432377a286f003c093b.svg";
export { ForwardRef as ReactComponent };